import { Link, Typography } from '@mui/material';
import { detailLabelCss, detailLinkCss, detailRowCss, detailValueCss } from './sourcing-detail-panel.styles';

export interface DetailRowProps {
  readonly label: string;
  readonly value: string | null | undefined;
  readonly isLink?: boolean;
}

export function DetailRow({ label, value, isLink }: DetailRowProps) {
  return (
    <div css={detailRowCss}>
      <Typography css={detailLabelCss}>{label}</Typography>
      {isLink && value ? (
        <Link
          href={value.startsWith('http') ? value : `https://${value}`}
          target='_blank'
          rel='noopener noreferrer'
          css={detailLinkCss}
        >
          {value.replace(/^https?:\/\//, '')}
        </Link>
      ) : (
        <Typography css={detailValueCss}>{value ?? '—'}</Typography>
      )}
    </div>
  );
}
